<template>
  <div class="smsTemplateDialog">
    <el-form :model="form" :rules="rules" ref="templateForm">
      <el-form-item
        label="模板名称"
        :label-width="formLabelWidth"
        prop="templateName"
      >
        <el-input v-model="form.templateName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="模板内容"
        :label-width="formLabelWidth"
        prop="templateContent"
      >
        <el-input type="textarea" v-model="form.templateContent"></el-input>
        <span style="font-size: 2px"
          >您当前输入
          <span style="font-size: 5px; color: red"> {{ words }} </span>个字
        </span>
      </el-form-item>
      <el-form-item
        label="申请描述"
        :label-width="formLabelWidth"
        prop="remark"
      >
        <el-input type="textarea" v-model="form.remark"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="smsData.show = false">取 消</el-button>
      <el-button type="primary" @click="submitTemplate('templateForm')"
        >确 定</el-button
      >
    </div>
  </div>
</template>

<script>
import { addSMSTemplate, updateSMSTemplate, findTemplate } from "@/api/index";

export default {
  name: "smsTemplateDialog",
  props: {
    smsData: Object,
  },
  data() {
    return {
      words: 0,
      form: {
        id: null,
        templateName: "",
        templateContent: "",
        remark: "",
      },
      formLabelWidth: "80px",
      rules: {
        templateName: [
          { required: true, message: "请填写模板名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        templateContent: [
          { required: true, message: "请填写模板内容", trigger: "blur" },
          {
            min: 2,
            max: 200,
            message: "长度在 2 到 200 个字符",
            trigger: "blur",
          },
        ],
        remark: [
          { required: true, message: "请填写申请描述", trigger: "blur" },
          {
            min: 2,
            max: 300,
            message: "长度在 2 到 300 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    submitTemplate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.smsData.operation == "add") {
            addSMSTemplate(this.form).then((res) => {
              if (res.success == true) {
                this.$message({
                  showClose: true,
                  message: "新增成功",
                  type: "success",
                });
                this.$emit("result");
                this.smsData.show = false;
              } else {
                this.$notify.error({
                  title: "错误",
                  message: res.message,
                });
              }
            });
          } else {
            updateSMSTemplate(this.form).then((res) => {
              if (res.success == true) {
                this.$message({
                  showClose: true,
                  message: "修改成功",
                  type: "success",
                });
                this.$emit("result");
                this.smsData.show = false;
              } else {
                this.$notify.error({
                  title: "错误",
                  message: res.message,
                });
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  created() {
    if (this.smsData.operation == "edit" && this.smsData.id != null) {
      findTemplate(this.smsData.id).then((res) => {
        if (res.success == true) {
          this.form = {
            id: this.smsData.id,
            templateName: res.result.templateName,
            templateContent: res.result.templateContent,
            remark: res.result.remark,
          };
        } else {
          this.$notify.error({
            title: "错误",
            message: res.message,
          });
        }
      });
    }
  },
  watch: {
    "form.templateContent": function (newValue, oldValue) {
      this.words = Array.from(newValue).length;
    },
  },
};
</script>
<style lang="scss">
.smsTemplateDialog {
  .dialog-footer {
    text-align: right;
  }
}
</style>
